export default "__VITE_ASSET__CPomzpi1__"